import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen2() {
    const { t } = useLang('theProductV2.Screen4');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen2-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen2-V2"
            data-section-id={'rapid-mag-Screen2-V2'}
            data-section-title={t('title')}
        >
            <div className="Screen2-info">
                <div className="Screen2-label">{t('label')}</div>
                <div className="Screen2-title">{t('title')}</div>
                <div className="Screen2-desc">{t('desc')}</div>
                <div className="Screen2-tips">{t('tips')}</div>
            </div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762138410254/screen2.png',
                        'https://websiteoss.ecoflow.com/upload/image/1762138410968/screen2.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547553714/Screen4-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547520264/Screen4-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
